<template>
  <div class="quantum-super-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$|ψ⟩ = α|0⟩ + β|1⟩$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
             <label>系统状态</label>
             <span class="val">{{ hasMeasured ? '已坍缩 (Classical)' : '相干叠加中 (Quantum)' }}</span>
          </div>
          <div class="hud-item orange">
            <label>左侧出现概率</label>
            <span class="val">{{ (probLeft * 100).toFixed(0) }} %</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 概率密度波 (Probability Cloud) -->
          <g v-if="!hasMeasured">
             <defs>
               <radialGradient v-for="i in 2" :key="'g'+i" :id="'grad'+i">
                  <stop offset="0%" stop-color="#0ea5e9" stop-opacity="0.8"/>
                  <stop offset="100%" stop-color="#0ea5e9" stop-opacity="0"/>
               </radialGradient>
             </defs>
             <!-- 两个潜在状态 -->
             <circle :cx="120" :cy="120 + Math.sin(time)*10" :r="25 + Math.sin(time*2)*5" fill="url(#grad1)" />
             <circle :cx="330" :cy="120 - Math.sin(time)*10" :r="25 + Math.cos(time*2)*5" fill="url(#grad2)" />
             <text x="225" y="60" text-anchor="middle" fill="#64748b" font-size="10">叠加态：粒子同时处于 A 和 B</text>
          </g>

          <!-- 测量后的坍缩状态 (Collapsed State) -->
          <g v-else>
             <circle :cx="collapsedPos" cy="120" r="8" fill="#f43f5e" filter="url(#glow-q)" />
             <text :x="collapsedPos" y="150" text-anchor="middle" fill="#f43f5e" font-size="11" font-weight="900">观测结果：{{ collapsedPos < 200 ? '状态 A' : '状态 B' }}</text>
          </g>

          <defs>
             <filter id="glow-q"><feGaussianBlur stdDeviation="3" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：在不对量子系统进行观测时，它同时包含所有可能的状态；观测会导致波函数骤然收缩。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节 A 态权重 (α)：{{ (probLeft*100).toFixed(0) }}</label>
                 <el-slider v-model="probLeftSlider" :min="0" :max="100" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="danger" size="small" @click="measure" :disabled="hasMeasured">执行测量 (观测)</el-button>
                 <el-button size="small" @click="reset">重载叠加</el-button>
              </div>
           </div>
        </div>
        
        <!-- 高对比度蓝色专业卡片加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-magic-stick"></i></div>
           <div class="text-content">
             <p><strong>实战物理/量子计算：</strong>叠加态是量子计算机超越传统机器的奥秘。<strong>解惑：</strong>这就是“薛定谔的猫”实验。<strong>观察：</strong>只要你不点测量，蓝色概率云就在两边晃动。你一旦点击按钮，宇宙必须在 A 和 B 之间做个选择，概率波瞬间**瞬间消失**成唯一的红点。由于这一物理律，量子比特可以实现爆发式的计算速度。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'QuantumStateSuperpositionProViz',
  data() {
    return {
      probLeftSlider: 50,
      hasMeasured: false,
      collapsedPos: 0,
      time: 0
    }
  },
  computed: {
    probLeft() { return this.probLeftSlider / 100; }
  },
  mounted() { this.animate(); },
  methods: {
    animate() {
       this.time += 0.05;
       this.animFrame = requestAnimationFrame(this.animate);
    },
    measure() {
       this.hasMeasured = true;
       // Collapse based on probability α²
       this.collapsedPos = Math.random() < this.probLeft ? 120 : 330;
    },
    reset() {
       this.hasMeasured = false;
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.quantum-super-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
